angular.module('psModule').controller('SimpleModalCtrl', ['$scope', 'header', 'body', function($scope, header, body){

    $scope.header = header;
    $scope.body = body;


}]);
